import Icon from '2-core-elements/Icon/Icon';

export type ProgressTrackerItem = {
    stepNumber: number;
    stepNumberLabel: string;
    label: string;
}

interface ProgressTrackerProps {
    steps: ProgressTrackerItem[];
    activeStep: number;
}

const ProgressTracker = ({ steps, activeStep }: ProgressTrackerProps): JSX.Element => {
    return (
        <div className="progress-tracker-wrapper">
            {steps.map(step => {
                const { stepNumber, stepNumberLabel, label } = step;

                const isActive = stepNumber === activeStep;
                const isSuccess = stepNumber < activeStep;

                let itemClass = `progress-tracker-item`;

                itemClass += isActive ? ` is-active` : ``;

                itemClass += isSuccess ? ` is-success` : ``;

                return (
                    <div className={itemClass} key={`progress-item-${stepNumber}`}>
                        <div className="progress-tracker-content">
                            <div className="progress-tracker-number">
                                <Icon icon="check" className="progress-tracker-icon-success" />
                                <span className="tracker-number">
                                    {stepNumberLabel}
                                </span>
                            </div>
                            <div className="progress-tracker-label">
                                {label}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ProgressTracker;
